import { render, staticRenderFns } from "./user-car-info.vue?vue&type=template&id=2549da1c&"
import script from "./user-car-info.vue?vue&type=script&lang=js&"
export * from "./user-car-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports